<template>
<div>
    <editor 
        class="json-editor"
        v-model="text" 
        @init="editorInit" 
        lang="javascript" 
        theme="dawn" 
        height="200px" >

    </editor>
    <error-message v-if="error" :message="'Invalid json!'" :fieldName="'json-editor'"/>
</div>
    
</template>

<script>

import VueAceEditor from 'vue2-ace-editor';
import ErrorMessage from '../Errors/ErrorMessage.vue';

import ace from 'brace'
import 'brace/ext/language_tools';
import 'brace/mode/javascript'
import 'brace/snippets/javascript';
import 'brace/theme/dawn';

export default {
    name: 'json-editor',
    components: {
        'Editor': VueAceEditor,
        ErrorMessage
    },
    created() {
        this.text = JSON.stringify(this.value);
    },
    methods: {
        editorInit() {
            require("brace/ext/language_tools");
            require("brace/mode/javascript");
            require("brace/snippets/javascript");
            require("brace/theme/dawn");
        }
    },
    watch: {
        text(value) {
            try {
                this.json = JSON.parse(value);
                this.error = false;
            } catch {
                this.error = true;
            }
        },
        json(value) {
            this.$emit('input', value);
        },
        error(value) {
            this.$emit('error', value)
        }
    },
    data() {
        return {
            text: '',
            json: {},
            error: false
        };
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped src="./Styles/json-editor.scss">

</style>